export const PRISTINE = 'PRISTINE';
export const UPLOADING = 'UPLOADING';
export const REMOVING = 'REMOVING';
export const UPLOADED = 'UPLOADED';
